module.exports = __webpack_public_path__ + "img/handimage.b2b5851e.png";